import React, { useState } from "react";
import MediaQuery from 'react-responsive';
import "./Carousel-t.scss";

const initialImages = [
  {
    src: "assets/Home/Home3-2/priority_pass.png",
    title: "Priority Pass",
    description: "Gives you access to exclusive airport lounges worldwide.",
  },
  {
    src: "assets/Home/Home3-2/additional_cards.png",
    title: "Additional cards",
    description:
      "Get additional cards for family or anyone and enjoy more convenience.",
  },
  {
    src: "assets/Home/Home3-2/karta_points.png",
    title: "Karta Points",
    description:
      "Redeem your points at your preferred Airlines or Hotels.",
  },
  {
    src: "assets/Home/Home3-2/exclusive_events.png",
    title: "Exclusive Events",
    description: "Get access to exclusive events.",
  },
  {
    src: "assets/Home/Home3-2/insurances.png",
    title: "Insurance",
    description: "Feel secure with the insurance benefits of a Visa Infinite card.",
  },
  {
    src: "assets/Home/Home3-2/karta_cash.png",
    title: "Karta Cash",
    description: "Send money and make payments to anyone and anytime.",
  },
  {
    src: "assets/Home/Home3-2/europe_tax_refund.png",
    title: "Europe tax refund",
    description: "Get your European transaction tax refund in just 3 easy steps.",
  },
  {
    src: "assets/Home/Home3-2/concierge.png",
    title: "Concierge 24/7",
    description: "WhatsApp customer service in your language, with the understanding and care you deserve.",
  },
];

const totalImages = initialImages.length;

const Carousel = () => {
  const [visibleImages, setVisibleImages] = useState(initialImages.slice(0, 3));
  const [isAnimating, setIsAnimating] = useState(false);
  const [index, setIndex] = useState(2);

  const slideRight = () => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    const animatingImages = visibleImages.map((img, i) => ({
      ...img,
      exiting: i === 0,
      entering: false
    }));
    setVisibleImages(animatingImages);
    const nextIndex = (index + 1) % initialImages.length;
    setTimeout(() => {
      const nextImage = {
        ...initialImages[nextIndex],
        entering: true
      };
      const newImages = [...animatingImages.slice(1), nextImage];
      
      setVisibleImages(newImages);
      setIndex(nextIndex);
      
      setTimeout(() => {
        setVisibleImages(prev => 
          prev.map(img => ({
            ...img,
            entering: false,
            exiting: false
          }))
        );
        setIsAnimating(false);
      }, 300);
    }, 300);
  };

  const progress = ((index + 1) / (totalImages) * 100).toFixed(2);

  return (
    <>
      <MediaQuery maxWidth={899.99} minWidth={600}>
        <div className="carousel-body-t">
          <div className="carousel-container">
            <div className="carousel-track">
              {visibleImages.map((img, i) => (
                <div 
                  key={`${img.title}-${i}`} 
                  className={`carousel-item ${img.exiting ? 'item-exit' : ''} ${img.entering ? 'item-enter' : ''}`}
                >
                  <img src={img.src} alt={`Slide ${i}`} />
                  <div className="carousel-text">
                    <div className="carousel-content">{img.title}</div>
                    <div className="carousel-description">{img.description}</div>
                  </div>
                </div>
              ))}
            </div>
            <div style={{width: '100%', justifyItems: 'center'}}>
                <div className="progress-bar">
                  <div className="progress" id="progress" style={{ width: `${progress}%` }}></div>
                </div>
              </div>
            </div>
          <button className="carousel-button right" onClick={slideRight} disabled={isAnimating}>
            <img src="assets/Home/Home3-2/arrow.svg" alt="Next" />
          </button>
        </div>
      </MediaQuery>
      <MediaQuery maxWidth={599.99}>
        <div className="carousel-body-xt">
          <div className="carousel-container">
            <div className="carousel-track">
              {visibleImages.map((img, i) => (
                <div 
                  key={`${img.title}-${i}`} 
                  className={`carousel-item ${img.exiting ? 'item-exit' : ''} ${img.entering ? 'item-enter' : ''}`}
                >
                  <img src={img.src} alt={`Slide ${i}`} />
                  <div className="carousel-text">
                    <div className="carousel-content">{img.title}</div>
                    <div className="carousel-description">{img.description}</div>
                  </div>
                </div>
              ))}
            </div>
            <div style={{width: '100%', justifyItems: 'center'}}>
                <div className="progress-bar">
                  <div className="progress" id="progress" style={{ width: `${progress}%` }}></div>
                </div>
              </div>
            </div>
          <button className="carousel-button right" onClick={slideRight} disabled={isAnimating}>
            <img src="assets/Home/Home3-2/arrow.svg" alt="Next" />
          </button>
        </div>
      </MediaQuery>
    </>
  );
};

export default Carousel;